import React from 'react';
import { ReactComponent as DownloadIcon } from "../../assets/img/svg/fi_download.svg";
import { ReactComponent as PdfIcon } from "../../assets/img/svg/pdfIcon.svg"
import { downLoadFile } from 'views/pages/manage/unAssigned/collectPayment/selectPaymentMode/components/common';
import moment from 'moment';
import { parse2Digit } from 'views/pages/manage/unAssigned/otherCharges/otherChargeDetails/OtherChargeList';
import { maskEmail, maskPhoneNumber } from 'views/pages/manage/unAssigned/collectPayment/selectPaymentMode/paymentLink/utils';

export const studentDetails = [
  { key: "psid", label: "PSID", renderData: (val) => val},
  { key: "studentName", label: "Student Name", renderData: (val) => val },
  { key: "appId", label: "Application No.", renderData: (val) => val },
  { key: "studentEmailId", label: "Email ID", renderData: (val) => maskEmail(val) },
  { key: "studentFatherName", label: "Father’s name", renderData: (val) => val },
  { key: "phoneNumber", label: "Phone Number", renderData: (val) => maskPhoneNumber(val) },
  { key: "studentAddress", label: "Address", renderData: (val) => val },
  { key: "city", label: "City", renderData: (val) => val },
  { key: "state", label: "State", renderData: (val) => val },
];
export const courseDetails = [
  { key: "outCourseId", label: "Course Id", renderData: (val) => val },
  { key: "outTerm", label: "Term", renderData: (val) => val },
];

export const transferInDetail = [
  { key: "requestNo", label: "Request No.", renderData: (val) => val },
  { key: "effectiveDate", label: "Effective date", renderData: (val) => val },
  { key: "currentBranch", label: "Current branch", renderData: (val) => val },
  { key: "inCourseId", label: "Course ID", renderData: (val) => val },
  { key: "inTerm", label: "Term", renderData: (val) => val },
  { key: "transferType", label: "Transfer type", renderData: (val) => val },
  { key: "transferReason", label: "Transfer reason", renderData: (val) => val },
  { key: "minReceiptDate", label: "Min. receipt date", renderData: (val) => val },
  { key: "remark", label: "Remark", renderData: (val) => val },
  { key: "requestForm", label: "Request form", type: 'file', renderData: (val) => val },
];

export const transferDetail = {
  psid: 12344455555,
  studentName: "Shresth",
  appliactionNo: 234512,
  studentEmailId: 'shresth@gmail.com',
  fatherName: 'Rajendra',
  phoneNumber: 6306385689,
  studentAddress: 'abc 242',
  city: "Prayagraj",
  state: 'UP',
  courseIds: [7123456, 7123457],
  term: [2325, 2324],

  // Added dummy values from transferInDetail
  requestNo: 'REQ-20250708-001',
  effectiveDate: '2025-07-15',
  currentBranch: 'Lucknow Campus',
  courseId: 'CSE2025',
  term: 'Term 5',
  transferType: 'Internal',
  transferReason: 'Relocation to another city',
  requestForm: 'Digital Form',
  minReceiptDate: '2025-07-10',
  remark: 'Student transferred to a new batch',
};
export const statusStyle = {
  Rejected: {
    backgroundColor: "#F9D9D7",
    color: "#B32306",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  "Auto-Rejected": {
    backgroundColor: "#F9D9D7",
    color: "#B32306",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Approved: {
    backgroundColor: "#BBE2CE",
    color: "#0B442D",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Complete: {
    backgroundColor: "#BBE2CE",
    color: "#0B442D",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  Pending: {
    backgroundColor: "#FFEDC8",
    color: "#705010",
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  },
  "Action Needed": {
    backgroundColor: "#D6E9FF", // light blue background
    color: "#004085",           // dark navy text
    padding: "4px 11px",
    fontSize: "12px",
    borderRadius: "8px",
  }

};

export const statusMapping = {
  COMPLETED: "Complete",
  PENDING: "Pending",
  REJECTED: "Rejected",
  IN_PROCESS: "Pending",
  ACTION_NEEDED: "Action Needed"
};
export const logsList = [
  {
    "title": "L2 Approval",
    "status": "completed",
    "remark": null,
    "createdOn": "2025-07-16T09:33:55.000+00:00",
    "createdBy": "A27065",
    "updatedOn": "2025-07-16T09:33:55.000+00:00",
    "updatedBy": "A27065"
  },
  {
    "title": "L1 Approval",
    "status": "completed",
    "remark": null,
    "createdOn": "2025-07-15T09:33:55.000+00:00",
    "createdBy": "A27065",
    "updatedOn": "2025-07-15T09:33:55.000+00:00",
    "updatedBy": "A27065"
  },
  {
    "title": "Sent for approval",
    "status": "completed",
    "remark": null,
    "createdOn": "2025-07-14T09:33:55.000+00:00",
    "createdBy": "A27065",
    "updatedOn": "2025-07-14T09:33:55.000+00:00",
    "updatedBy": "A27065"
  },
  {
    "title": "Request created",
    "status": "completed",
    "remark": null,
    "createdOn": "2025-07-13T09:33:55.000+00:00",
    "createdBy": "A27065",
    "updatedOn": "2025-07-13T09:33:55.000+00:00",
    "updatedBy": "A27065"
  }
]

export const getProgressStepList = ({
  hasL2Approval = false,
  isSuperleap = true,
  transferPolicy = null,
} = {}) => {
  const steps = [
    { title: "Request created" },
     // Always mandatory
  ];
  if(transferPolicy == 'ACQUISITION')
    steps.push({ title: "Request auto approved"})
  else{
    steps.push({ title: "Sent for approval" });
    steps.push({ title: "L1 Approval" })
    steps.push({ title: "L2 Approval" });
  }

  // Add system approval with dynamic last sub-step
  steps.push(
    {
      title: "System approval",
      subSteps: [
        { title: "Application created" },
        { title: "Charges applied" },
        { title: "Receipting completed" },
        {
          title: isSuperleap
            ? "Superleap opportunity"
            : "Salesforce opportunity"
        }
      ]
    },
    { title: "Transfer processed" }
  );

  return steps;
};


// export const generatingProgressStepList = (progressStepList = [], logs = []) => {
//   debugger
//   if (logs.length === 0) return [];

//   const stopAt = logs[0].title;
//   const tempStepList = [];

//   for (let step of progressStepList) {
//     tempStepList.push(step);
//     if (step === stopAt) break;
//   }

//   return tempStepList;
// };

// Create a default upcoming step
const createUpcomingStep = (title) => ({
  title,
  status: 'upcoming'
});

// Normalize title for consistent keying
const normalize = (title='') => title.trim().toLowerCase();
// Build a map of the most recent log per title
const buildLatestLogMap = (logs) => {
  const map = new Map();

  for (const log of logs) {
    const key = normalize(log.title);
    const current = map.get(key);

    if (!current || new Date(log.updatedOn) > new Date(current.updatedOn)) {
      map.set(key, log);
    }
  }

  return map;
};


// Identify which step titles (including substeps) are allowed based on the first log
const getAllowedTitles = (steps, stopAtTitle) => {
  const allowed = new Set();
  const stopKey = normalize(stopAtTitle);
  let stop = false;

  for (const step of steps) {
    if (stop) break;

    const stepKey = normalize(step.title);
    allowed.add(stepKey);

    if (stepKey === stopKey) break;

    if (step.subSteps) {
      for (const sub of step.subSteps) {
        const subKey = normalize(sub.title);
        allowed.add(subKey);

        if (subKey === stopKey) {
          stop = true;
          break;
        }
      }
    }
  }

  return allowed;
};


// Get status for any step/substep based on allowed titles and log map
const resolveStepStatus = (
  title,
  allowedTitles,
  logMap,
  isRemarkNedded,
  step
) => {
  const key = normalize(title);

  return allowedTitles.has(key) && logMap.has(key)
    ? { ...step, ...logMap.get(key), isRemarkNedded }
    : createUpcomingStep(title);
};


// ---------- Main Generator ----------

export const generateProgressSteps = (progressSteps = [], logs = []) => {
  if (logs.length === 0) {
    return progressSteps.map(step => ({
      ...createUpcomingStep(step.title),
      ...(step.subSteps && {
        subSteps: step.subSteps.map(sub =>
          createUpcomingStep(sub.title)
        )
      })
    }));
  }

  const stopAtTitle = logs[0].title;
  const allowedTitles = getAllowedTitles(progressSteps, stopAtTitle);
  const logMap = buildLatestLogMap(logs);

  return progressSteps.map(step => {
    const mainStep = resolveStepStatus(
      step.title,
      allowedTitles,
      logMap,
      step?.isRemarkNeeded,
      step
    );

    if (!step.subSteps) return mainStep;

    return {
      ...mainStep,
      subSteps: step.subSteps.map(sub =>
        resolveStepStatus(
          sub.title,
          allowedTitles,
          logMap,
          sub?.isRemarkNeeded,
          sub
        )
      )
    };
  });
};


export const NOTIFY_CHANNELS = [
  { label: "Email", name: "email" },
];

export const logsValueMapping = {
  "Request created": "updatedBy",
  "Sent for approval": "updatedBy",
  "L1 Approval": "updatedBy",
  "L2 Approval": "updatedBy",
  "System approval": "updatedBy",
  "Application created": "updatedBy",
  "Charges applied": "updatedBy",
  "Receipting completed": "updatedBy",
  "Superleap opportunity": "updatedBy",
  "Salesforce opportunity": "updatedBy",
  "Student matriculated": "updatedBy",
  "Transfer processed": "updatedBy",
  "Print tranfer certificate": "updatedBy",
  "Send notification": "updatedBy",
  "View fee calculation": "updatedBy"
}
export const getCreateReceiptTemplateData = (data) => {
  return {
    name: 'transferCertificate',
    candidateName: data?.studentName,
    psid: data?.psid,
    fatherName: data?.fathersName,
    address: data?.address,
    email: data?.emailId,
    dateOfTransfer: data?.transferDate && moment(data?.transferDate).format('DD-MM-YYYY'),
    transferAction: data?.transferType,
    reason: data?.transferReason,
    financialDetails: {
      "Transfer From": data?.outBusinessAreaDesc,
      "Transfer To": data?.inBusinessAreaDesc ,
      "Term": data?.term,
      "Course ID": data?.courseName,
      "Total Course Fee": parse2Digit(data?.totalCourseFee),
      "Total No. of Installment": data?.totalInstallment,
      "Eligible Concession (Total Percent)": parse2Digit(data?.totalPercentageConcession),
      "Eligible Concession (Total in Value)": parse2Digit(data?.totalValueConcession),
      "Concession Type": data?.concessionType && data?.concessionType.join(", "),
      "Category Name": data?.categoryName && data?.categoryName.join(", "),
      "Lump sum Benefit": parse2Digit(data?.lumpSumBenefit),
      "Reg Fee Received": parse2Digit(data?.paidRegistrationFess),
      "Admission Fee Received": parse2Digit(data?.paidAdmissionFess),
      "Tuition Fee Received": parse2Digit(data?.paidTuitionFess),
      "Total Amount Received": parse2Digit(data?.totalPaidAmount),
      "Balance":parse2Digit(data?.totalBalanceAmount),
      "Balance Reg. Fee":parse2Digit(data?.balanceRegistrationFess),
      "Balance Adm. Fee":parse2Digit(data?.balanceAdmissionFess),
      "Last Installment Partially Paid": data?.lastInstallmentPartiallyPaid,
      "Amount Paid Partially Last installment":parse2Digit(data?.lastInstallmentPartiallyPaidAmount),
      "No. of Installment Paid": data?.totalInstallmentPaid
    }

  }

}
export const displayFile = (value) => {
  if (value.length) {
    return <div className="d-flex flex-wrap">
      {value.map((item, index) => (
        <div key={index} className="d-flex align-items-center me-3 mb-2">
          <PdfIcon width={22} height={22} className="me-1" />
          <span className="ml-1">Attachment {index + 1}</span>
          <span className="cursor ml-1" onClick={() => downLoadFile(true, item)}>
            <DownloadIcon />
          </span>
        </div>
      ))}
    </div>

  } else
    return "-"
}
export const getLabelByValue = (dropdownList, value) => {
  const item = dropdownList.find((opt) => opt.value === value);
  return item ? item.label : null;
}

export const transferTypeDesc = {
  IBTR: "Inter-Branch Transfer",
  CRCG: "Course Change",
  STCG: 'Stream Change'
}
export const transferReasonDesc = {
  APBM: "Approved by Branch Manager",
  APRG: "Approval from Registered office",
  AUDT: "Audit Cases",
  HLTH: "Health issue",
  HOST: "Hostel Issue",
  PATR: "Parents Transfer",
  RETN: "To Retain the Student",
}